import z from 'zod';
import { request } from '../../utils/request';
import { UserInformationSchema } from '../../schemas/userSchema';

type mainContent = z.infer<typeof UserInformationSchema>;
type reqBody = Partial<mainContent>;

export const updateUserProfileInfo = (data: reqBody, authToken: string) =>
  request({
    method: 'PATCH',
    url: `/auth/profile/generic`,
    formData: {
      type: 'store-owner',
      data,
    },
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
